// extracted by mini-css-extract-plugin
module.exports = {"attachmentDropdown":"kAAE4ALQ","attachmentButton":"azF13Qqq","infoWrapper":"q8kehs_o","pillLabel":"EabHRthD"};